import IncidentTypesCard from "@/components/features/settings/defaults/matter-types/MatterTypesCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/matter-types")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsTypes)) {
    return <GlobalNotAuthorized />;
  }

  return <IncidentTypesCard />;
}
